import axios, { AxiosPromise } from 'axios';

class UserIP {
  getUserIP: () => AxiosPromise<{ ip: string }> = async () =>
    axios.get('https://api.ipify.org/?format=json');
}

export const userIP = new UserIP();
